import { v4 as uuidv4 } from 'uuid';

export const createUserLocalStorage = (): void => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
        const userId = uuidv4();
        const firstEnterTimeStamp = Date.now();
        const formatted = new Date(firstEnterTimeStamp).toLocaleString();
        localStorage.setItem('userId', userId);
        localStorage.setItem('userFirstEnter', formatted);
    }
};

export const clearUserLocalStorage = (): void => {
    localStorage.removeItem('userId');
    localStorage.removeItem('userFirstEnter');
};

export const getUserLocalStorage = (): { userId: string; userFirstEnter: string } => {
    const userId = localStorage.getItem('userId');
    const userFirstEnter = localStorage.getItem('userFirstEnter');
    if (userId && userFirstEnter) {
        return { userId, userFirstEnter };
    }
    return { userId: '', userFirstEnter: '' };
};
